import PropTypes from 'prop-types';
import React from 'react';

import connect from 'components/lib/connect';
import CustomerProfileDef from 'models/customer_profile_def';
import ExpandableProfileCard from 'components/customer/profile/expandable_profile_card';
import {
  countSubgroupCustomAttributes,
  getAttributeDefsToShow,
  renderCustomAttributes,
  renderCustomAttributesSubgroup,
} from './lib/custom_attributes_helper';
import ProfileCardDef, { ProfileCardType } from 'models/configuration/profile_card_def';

export function CustomAttributes({ customAttributes, customerProfileDef, profileCardDef }) {
  const attrDefs = getAttributeDefsToShow(profileCardDef, customerProfileDef, customAttributes);
  const numSubgroupAttrDefs = countSubgroupCustomAttributes(profileCardDef, customerProfileDef, customAttributes);

  if (!attrDefs.length && !numSubgroupAttrDefs) {
    return null;
  }

  return (
    <ExpandableProfileCard title={profileCardDef.label || 'Information'} data-aid="customAttributes">
      {renderCustomAttributes(attrDefs, customAttributes, ProfileCardType.CUSTOM_ATTRS)}
      {renderCustomAttributesSubgroup(
        profileCardDef,
        customerProfileDef,
        customAttributes,
        ProfileCardType.CUSTOM_ATTRS
      )}
    </ExpandableProfileCard>
  );
}

CustomAttributes.propTypes = {
  customAttributes: PropTypes.object,
  customerProfileDef: PropTypes.instanceOf(CustomerProfileDef),
  profileCardDef: PropTypes.instanceOf(ProfileCardDef).isRequired,
};

function mapStateToProps({ getProvider }) {
  const profileProvider = getProvider('profile');
  const customerProfileDefProvider = getProvider('customerProfileDef');

  const profile = profileProvider.get();

  return {
    customAttributes: profile && profile.customAttributes,
    customerProfileDef: customerProfileDefProvider.get(),
  };
}

const CustomAttributesContainer = connect(mapStateToProps)(CustomAttributes);
export default CustomAttributesContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes.jsx